__turbopack_context__.v({
  "contactModal": "i-W4ua_contactModal",
  "content": "i-W4ua_content",
  "desktop": "i-W4ua_desktop",
  "forgotPasswordForm__hVwb": "i-W4ua_forgotPasswordForm__hVwb",
  "forgotPasswordForm__t4KkE": "i-W4ua_forgotPasswordForm__t4KkE",
  "loginTroubleshootingModal": "i-W4ua_loginTroubleshootingModal",
  "mobile": "i-W4ua_mobile",
  "news___2C30P": "i-W4ua_news___2C30P",
  "news__vwqO": "i-W4ua_news__vwqO",
  "root": "i-W4ua_root",
});
